import { useCallback } from 'react';
import axios from 'axios';

export const useClientDataLoaders = ({
  BACKEND_URL,
  user,
  setBookingHistory,
  setUpcomingBookings,
  setRecentCancelledBookings,
  setClientAcceptedQuickCuts
}) => {
  const loadClientAcceptedQuickCuts = useCallback(async () => {
    try {
      if (user?.user_type !== 'client') return;
      const token = localStorage.getItem('token');
      if (!token) return;

      const response = await axios.get(`${BACKEND_URL}/api/quick-cuts/client/accepted`, {
        headers: { Authorization: `Bearer ${token}` }
      });

      setClientAcceptedQuickCuts(response.data.quick_cuts || []);
    } catch (error) {
      console.error('Error loading client accepted quick cuts:', error);
      setClientAcceptedQuickCuts([]);
    }
  }, [BACKEND_URL, setClientAcceptedQuickCuts, user?.user_type]);

  const loadClientHistory = useCallback(async () => {
    try {
      if (user?.user_type !== 'client') return;
      const token = localStorage.getItem('token');
      if (!token) return;

      const response = await axios.get(`${BACKEND_URL}/api/client/history`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setBookingHistory(response.data.history || []);
    } catch (error) {
      console.error('Error loading client history:', error);
    }
  }, [BACKEND_URL, setBookingHistory, user?.user_type]);

  const loadUpcomingBookings = useCallback(async () => {
    try {
      if (user?.user_type !== 'client') return;
      const token = localStorage.getItem('token');
      if (!token) return;

      const response = await axios.get(`${BACKEND_URL}/api/bookings/client`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      const bookings = response.data.bookings || [];
      setUpcomingBookings(bookings);
      if (bookings.length > 0) {
        setRecentCancelledBookings((prev) => {
          const updated = { ...prev };
          const barbershopIds = new Set(bookings.map((booking) => booking.barbershop_id).filter(Boolean));
          Object.entries(updated).forEach(([key, value]) => {
            if (value?.barbershopId && barbershopIds.has(value.barbershopId)) {
              delete updated[key];
            }
          });
          return updated;
        });
      }
    } catch (error) {
      console.error('Error loading upcoming bookings:', error);
    }
  }, [BACKEND_URL, setRecentCancelledBookings, setUpcomingBookings, user?.user_type]);

  return {
    loadClientAcceptedQuickCuts,
    loadClientHistory,
    loadUpcomingBookings
  };
};
